export const COOKIE_SESSION_TOKEN = "laravel_session";
export const COOKIE_OAUTH_TOKEN = "oauth_token";
export const COOKIE_ACTIVE_MEMBERSHIP = "cjp_membership";

export default {
  COOKIE_SESSION_TOKEN,
  COOKIE_OAUTH_TOKEN,
  COOKIE_ACTIVE_MEMBERSHIP,
};
